module.exports = __webpack_public_path__ + "static/img/mobile_hwaq_banner.9ba1655.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile_hwaq_banner.png
// module id = +ynJ
// module chunks = 21